/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetOrderPackage from '../services/GetOrderPackage';
import GetApprovedCustomerOrdersForCRS from '../services/GetApprovedCustomerOrdersForCRS';
import GetPackagedCustomerOrdersByOrderPackageID from '../services/GetPackagedCustomerOrdersByOrderPackageID';
import OrderPackageSelectOrdersView from '../views/OrderPackageSelectOrdersView/OrderPackageSelectOrdersView';

export default async function loadOrderPackageSelectOrdersView({orderPackageID, editable}) {

  const orderPackage = await GetOrderPackage(orderPackageID);

  let approvedOrders = []

  if (editable) {
    approvedOrders = await GetApprovedCustomerOrdersForCRS(orderPackage.crsInternalUserID);
  }

  const packagedOrders = await GetPackagedCustomerOrdersByOrderPackageID(orderPackageID);

  return new OrderPackageSelectOrdersView({
    orderPackageID,
    editable,
    model: new Backbone.Model({
      orderPackage,
      approvedOrders,
      packagedOrders
    })
  });
  
}